namespace TabAurous.Inventory {
    export interface MeltingItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        DesignId?: number;
        DesignCode?: string;
        Studded?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        AlloyRequired?: number;
        ConversionFactor?: number;
        ReceivableWeight?: number;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        CalcOnId?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        StockAllocation?: boolean;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        Purity?: number;
        PureWeight?: number;
        StoneRate?: number;
        OtherRate?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
    }

    export namespace MeltingItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.MeltingItems';
        export const deletePermission = 'Inventory:Melting:Delete';
        export const insertPermission = 'Inventory:Melting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Melting:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            Studded = "Studded",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            AlloyRequired = "AlloyRequired",
            ConversionFactor = "ConversionFactor",
            ReceivableWeight = "ReceivableWeight",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            CalcOnId = "CalcOnId",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            StockAllocation = "StockAllocation",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            Purity = "Purity",
            PureWeight = "PureWeight",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount"
        }
    }
}
